import styled from 'styled-components';
import { floatingComponentStyles } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';
import { PrimaryButton } from '../../Button';

export const PopoverContainer = styled.div`
  ${floatingComponentStyles};
  min-width: 300px;
  padding: 12px;
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 12px;
  padding: 12px 12px;
`;

export const Content = styled.div``;

export const Section = styled.div`
  margin-bottom: 16px;
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 16px 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 4px;
  cursor: pointer;
`;

export const ActionButton = styled(PrimaryButton)`
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 0;
  min-width: 0;
  display: flex;
  border-color: ${theme.colors.secondary300};

  &:hover {
    border-color: ${theme.colors.mainBlue};

    svg {
      path {
        fill: ${theme.colors.mainBlue};
      }
    }
  }
`;
